/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Balance_Gem_DescriptionInputs */

const en_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete daily Focus Challenges to keep earning more for free!`)
};

const ar_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل المهام اليومية تحديات التركيز للاستمرار في كسب المزيد مجانًا!`)
};

const de_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füllen Sie täglich Fokus Herausforderungen aus, um weiterhin kostenlos mehr zu verdienen!`)
};

const es_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Completa los Desafíos de Concentración diarios para seguir ganando más gratis!`)
};

const fr_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenez part aux Défi de Concentration journaliers et récoltez encore plus d'avantages gratuitement !`)
};

const it_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa le attività giornaliere della Sfida di Concentrazione per continuare a guadagnare di più gratuitamente!`)
};

const ja_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日集中チャレンジを達成すると、無料で貢献度を稼げます！`)
};

const ko_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 집중 챌린지를 완료하고 무료로 추가 획득하세요!`)
};

const pt_br_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua o Desafio de Foco diariamente para continuar ganhando mais!`)
};

const ru_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполняйте ежедневные Задания по фокусировке, чтобы получать больше бесплатных сюрпризов!`)
};

const th_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความท้าทายการโฟกัสรายวันให้สำเร็จเพื่อรับของฟรีเพิ่มเติม!`)
};

const tr_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz olarak daha fazla kazanmaya devam etmek için günlük Odaklanma Mücadelelerini tamamla!`)
};

const zh_cn_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成每日专注挑战，就能持续累积时光宝石！`)
};

const zh_tw_dialog_not_enough_balance_gem_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成每日專注挑戰，就能持續累積時光寶石！`)
};

/**
* | output |
* | --- |
* | "Complete daily Focus Challenges to keep earning more for free!" |
*
* @param {Dialog_Not_Enough_Balance_Gem_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_balance_gem_description = /** @type {((inputs?: Dialog_Not_Enough_Balance_Gem_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Balance_Gem_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "ar") return ar_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "de") return de_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "es") return es_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "fr") return fr_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "it") return it_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "ja") return ja_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "ko") return ko_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "ru") return ru_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "th") return th_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "tr") return tr_dialog_not_enough_balance_gem_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_balance_gem_description(inputs)
	return zh_tw_dialog_not_enough_balance_gem_description(inputs)
});